export class uploadUrl {
    SEND_FOR_SIGNATURE_URL = "sig/v1/signature/send-for-signature";
    SEND_FOR_SIGNATURE_WITH_TEXTid_URL = "sig/v1/signature/upload-with-textId";
    SET_ACCESS_URL = "sig/v1/signature/set-access";
    GET_SIGNATURE_STATUS_URL = "sig/v1/signature/status/{documentId}";
}